import React, { useState } from "react";
import { useEffect } from "react";
import { IoAddCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import DeleteButton from "../../components/DeleteButton";
import EditButton from "../../components/EditButton";
import FillingDataTable from "../../components/FillingDataTable";
import ModalAccessoriesMainSpecification from "../../components/accessories/ModalAccessoriesMainSpecification";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import { createItem, deleteItem, getItem } from "../../services/service";
import { useTranslation } from "react-i18next";
import { Context } from "../../context/MainSearchContext";
import { useContext } from "react";
import MainSearchInput from "../../components/search/MainSearchInput";
import { toast } from "react-toastify";
import TemDataTableInline from "../../components/TemDataTableInline";
import CopyButton from "../../components/CopyButton";
import TableComponent from "../../components/tableComponent/tableComponent";

const headerTable = [
  {
    name: "supplier",
    sort: true,
  },
  {
    name: "article",
    sort: true,
  },
  {
    name: "name",
    sort: true,
  },
  {
    name: "color",
    sort: true,
  },
  {
    name: "default",
    sort: false,
  },
  {
    name: "actions",
    sort: true,
  },
];

const bodyContent = [
  "supplierName",
  "article",
  "productName",
  "color",
  "default",
  "actions",
];

const SPEC_TABS = [
  {
    key: "MAIN",
    apiPath: "/v1/accessories/main/specification",
    titleKey: "table.accessories.accessories_main",
    modalTitleKey: "add_main_specification",
    showDefault: true,
  },
  {
    key: "TRACK",
    apiPath: "/v1/accessories/track/specification",
    titleKey: "table.accessories.accessories_track",
    modalTitleKey: "add_track_specification",
    showDefault: false,
  },
];

function AccessoriesMainSpecificationLayout({
  id,
  setSelectedMainSpecificationId,
  setSelectedParameterId,
  setSelectedDependSideLimitId,
  setSelectedDependSpecificationId,
}) {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.user);
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [itemOffset, setItemOffset] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDir, setSortDir] = useState("DESC");
  const [clear, setClear] = useState(false);
  const [specType, setSpecType] = useState("MAIN");
  const activeTab = SPEC_TABS.find((tab) => tab.key === specType) || SPEC_TABS[0];
  const apiPath = activeTab.apiPath;
  const [data, setData] = useState({
    data: [],
    recordsTotal: 0,
    pageCount: 1,
  });

  const [selectedAccessoriesId, setSelectedAccessoriesId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const { t } = useTranslation();
  const ctx = useContext(Context);
  const handleClose = () => {
    setOpen(false);
    setIsEdit(false);
    setSelectedAccessoriesId(null);
  };
  const handleOpen = () => {
    setOpen(true);
    setSelectedAccessoriesId(null);
  };
  const fetchData = async () => {
    const response = await createItem(
      `${process.env.REACT_APP_HOST_BASE_URL}${apiPath}/table`,
      token,
      {
        draw: 1,
        start: itemOffset,
        length: itemsPerPage,
        recordsTotal: 0,
        columns: [],
        order: [{ column: sortColumn, dir: sortDir }],
        search: { value: ctx.state, regex: true },
        filter: { accessoriesId: id },
      }
    );
    if (response.success) {
      setClear(false);
      let reviewData = response.data.data.map((item, index) => {
        return {
          ...item,
          color: item.textureName,
          selected: false,
          default: (
            <input
              type="checkbox"
              className="w-4 h-4 text-gray-500 border-gray-600 rounded focus:ring-gray-300"
              checked={!!item.default}
              readOnly
            />
          ),
          actions: (
            <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
              <CopyButton onclick={() => copyHandler(item.id)} />
              <EditButton onclick={() => editHandler(item.id)} />
              <DeleteButton onclick={() => deleteHandler(item.id)} />
            </div>
          ),
        };
      });
      setData({
        data: reviewData,
        recordsTotal: response.data.recordsFiltered,
        pageCount: Math.ceil(
          response.data.recordsFiltered / parseInt(itemsPerPage)
        ),
      });
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  useEffect(() => {
    if (clear) {
      fetchData();
    }
  }, [clear]);

  useEffect(() => {
    fetchData();
  }, [specType, itemOffset, itemsPerPage, data.recordsTotal, ctx.state]);

  // const sortFunction = (value) => {
  //   setSortColumn(value.field ? value.field : "id");
  //   setSortDir(value.sort === true ? "ASC" : "DESC");
  //   setClear(true);
  // };

  const handlePageClick = (event) => {
    setForcePage(event.selected);
    const newOffset =
      (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
    setItemOffset(newOffset);
  };

  const deleteHandler = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      setIsLoading(true);
      const response = await deleteItem(
        `${process.env.REACT_APP_HOST_BASE_URL}${apiPath}/${id}`,
        token
      );
      if (response.success) {
        fetchData();
        setIsLoading(false);
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };
  const copyHandler = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      setIsLoading(true);
      const response = await getItem(
        `${process.env.REACT_APP_HOST_BASE_URL}${apiPath}/copy/${id}`,
        token
      );
      if (response.success) {
        fetchData();
        setIsLoading(false);
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };

  const editHandler = async (id) => {
    setIsEdit(true);
    setSelectedAccessoriesId(id);
    setOpen(true);
  };

  const handleTabChange = (key) => {
    if (key === specType) return;
    // ochiq modal eski apiPath bilan saqlamasligi uchun
    setOpen(false);
    setIsEdit(false);
    setSelectedAccessoriesId(null);
    // pagination
    setItemOffset(0);
    setForcePage(0);
    setData({ data: [], recordsTotal: 0, pageCount: 1 });
    // quyi panellar (DEPEND / INNER / limit / parametrlar)
    setSelectedMainSpecificationId(null);
    setSelectedParameterId(null);
    setSelectedDependSideLimitId(null);
    setSelectedDependSpecificationId(null);
    setSpecType(key);
  };
  return (
    <>
      <ModalAccessoriesMainSpecification
        handleClose={handleClose}
        isEdit={isEdit}
        open={open}
        selectedAccessoriesId={selectedAccessoriesId}
        id={id}
        fetchData={fetchData}
        apiPath={apiPath}
        titleKey={activeTab.modalTitleKey}
        showDefault={activeTab.showDefault}
      />
      {isLoading ? (
        <h1>Loading...</h1>
      ) : (
        <>
          <div className="flex items-end justify-between border-b border-gray-200">
            <nav className="flex -mb-px space-x-8" aria-label="Tabs">
              {SPEC_TABS.map((tab) => (
                <div
                  key={tab.key}
                  onClick={() => handleTabChange(tab.key)}
                  aria-current={tab.key === specType ? "page" : undefined}
                  className={`${
                    tab.key === specType
                      ? "border-indigo-500 text-gray-900"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  } whitespace-nowrap py-3 px-1 border-b-2 text-xl font-semibold cursor-pointer`}
                >
                  {t(tab.titleKey)}
                </div>
              ))}
            </nav>
            <button
              className="flex items-center h-8 px-3 py-1 mb-2 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              onClick={handleOpen}
            >
              {t("action.add")}
              <IoAddCircleOutline className="w-4 h-4 ml-1" />
            </button>
          </div>
          <div className="flex items-center justify-between mt-3">
            <Select
              setItemsPerPage={setItemsPerPage}
              itemsPerPage={itemsPerPage}
            />
            <MainSearchInput />
          </div>
          <TableComponent
            transactions={data.data}
            bodyOfTable={bodyContent}
            headerOfTable={headerTable}
            rowHandler={(id) => {
              const updatedData = data.data.map((item) => {
                if (item.id === id) {
                  return {
                    ...item,
                    selected: true,
                  };
                } else {
                  return {
                    ...item,
                    selected: false,
                  };
                }
              });
              setData((prevState) => {
                return {
                  ...prevState,
                  data: updatedData,
                };
              });
              setSelectedMainSpecificationId(id);
              setSelectedParameterId(id);
              setSelectedDependSideLimitId(id);
              setSelectedDependSpecificationId(null);
            }}
            // sortFunction={sortFunction}
          />
          <Pagination
            handlePageClick={handlePageClick}
            pageCount={data.pageCount}
            forcePage={forcePage}
          />
        </>
      )}
    </>
  );
}

export default AccessoriesMainSpecificationLayout;
